import {Resource} from "./Resource";

export class ResourceStatistic {
  fromDate : string;
  toDate : string;
  Resources : Resource[];
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/ResourceStatistic.ts